import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTravelShootCreditBenefitsModal from './LandingPageLoyaltyTravelShootCreditBenefitsModal'

const image: App.Image = {
  id: 'r1z816jjifeqb5hwk50o',
  title: 'Pro photos on your trip',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTravelShootCredit(props: Props) {
  const { tier, benefit, benefitLabel } = props

  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTravelShootCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [showModal, benefit])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'sxVMmJF7FoHE2SQkbEvX',
      defaultMessage: 'Pro photos on your trip',
      description: 'Heading for loyalty Travelshoot photo credit benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'aaUpY_wfl1qhPiKJVbUL',
        defaultMessage: 'Details',
        description: 'Link to open Travelshoot credit benefit details modal',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'oqtMS3pCoIsmH5O7wLsf',
        defaultMessage: 'Make the memories last. Use your Travelshoot voucher to book a professional photo session at your destination\u2014perfect for couples, families, or solo travellers.',
        description: 'Description of the Travelshoot professional photo credit loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyTravelShootCredit
